export const env = {
    //PROD
    crew3 : "https://biospheres.game/api/crew3/",
    recaptchaKey : "6LfrZ8giAAAAAF7A1OS4uVFQjBLgFljR0gt-etJ-",
    subscriptionApi : "https://biospheres.game/api/subscribe",
    verifyEmailEndpoint : "https://biospheres.game/ki/api/account/email/verify",
    apiKey : "xdeVfneAJGrKxfsft57npDRwx6F0eH0T",
    kwerpInvadersLink : "https://biospheres.game/KwerpInvaders/index.html?v=0",
    discordLink : "https://discord.com/api/oauth2/authorize?client_id=1158772030804594769&redirect_uri=https%3A%2F%2Fbiospheres.game%2F&response_type=token&scope=identify",
}


// WEBPACK FOOTER //
// ./src/env.js